import { render, staticRenderFns } from "./USPCard.vue?vue&type=template&id=68f8a97a&"
import script from "./USPCard.vue?vue&type=script&lang=js&"
export * from "./USPCard.vue?vue&type=script&lang=js&"
import style0 from "./USPCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports